// extracted by mini-css-extract-plugin
export default {"statusWrapper":"MembershipStatusChip_statusWrapper__CB7RP","statusChipText":"MembershipStatusChip_statusChipText__WD7Ja"};